import { render, staticRenderFns } from "./GGCardTitle.vue?vue&type=template&id=6b8dfbec&"
import script from "./GGCardTitle.vue?vue&type=script&lang=js&"
export * from "./GGCardTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b8dfbec')) {
      api.createRecord('6b8dfbec', component.options)
    } else {
      api.reload('6b8dfbec', component.options)
    }
    module.hot.accept("./GGCardTitle.vue?vue&type=template&id=6b8dfbec&", function () {
      api.rerender('6b8dfbec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Global/GGCardTitle.vue"
export default component.exports